import React from 'react';
import { useLoaderData } from 'react-router-dom';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import MarkdownContent from '../../components/content/MarkdownContent';

/**
 * StaticPage Component
 *
 * Renders markdown content with consistent layout, styling, and navigation.
 * Used for Help Center, Safety, and Cancellation Options pages.
 *
 * Note: Privacy and Terms are no longer rendered here — they are served from
 * the database via LegalDocumentPage (SCRUM-2203 / MVP 1.40.3).
 */
export default function StaticPage() {
  const { content, title, error } = useLoaderData();

  if (error) {
    return (
      <>
        <Header />
        <main className="min-h-screen bg-gray-50 py-12">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white rounded-lg shadow p-8">
              <h1 className="text-2xl font-bold text-red-600 mb-4">Error Loading Page</h1>
              <p className="text-gray-600">{error}</p>
            </div>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <main className="min-h-screen bg-gray-50 py-8 sm:py-12">
        <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-sm p-6 sm:p-8 lg:p-12">
            {title && (
              <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8 border-b pb-4">
                {title}
              </h1>
            )}
            <MarkdownContent>{content}</MarkdownContent>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}
